import { ArrowForwardIos, ContentCopy, Delete, Message } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        border: '2px solid rgba(59, 130, 246, 0.3)',
        minWidth: "220px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #3b82f6, #2563eb)",
          width: "20px",
          height: "20px",
          top: "50%",
          left: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "12px",
          display: "flex",
          gap: "8px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#3b82f6"
            }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#ef4444"
            }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px"
        }}
      >
        <Message
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
            color: "#3b82f6"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "0.01em"
        }}>
          Mensagem
        </div>
      </div>

      <div style={{ 
        color: "#374151", 
        fontSize: "13px",
        lineHeight: "1.5",
        maxHeight: "100px",
        overflowY: "auto",
        padding: "8px",
        backgroundColor: "#f8fafc",
        borderRadius: "6px",
        border: "1px solid #e2e8f0"
      }}>
        {data.label}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(45deg, #3b82f6, #2563eb)",
          width: "20px",
          height: "20px",
          top: "50%",
          right: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});